
const digest = '627686e7a803b39ae1e18bd096f27d466294f42ee96008cb70bb867e57588b56';
const classes = {"wrapper":"_wrapper_91fi8_1"};
const css = `._wrapper_91fi8_1 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #f4f6f9;
  font-weight: 500;
  font-size: 14px;
  padding: 12px 20px;
  border-radius: 10px;
}
._wrapper_91fi8_1:hover {
  cursor: pointer;
  background-color: #eaedf3;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  